var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('iq-card', {
    scopedSlots: _vm._u([{
      key: "headerTitle",
      fn: function fn() {
        var _vm$$route$query;
        return [_c('div', {
          staticClass: "d-flex align-items-center"
        }, [!((_vm$$route$query = _vm.$route.query) !== null && _vm$$route$query !== void 0 && _vm$$route$query.vehicleId) ? _c('i', {
          staticClass: "fa fa-arrow-left mr-3 text-primary",
          staticStyle: {
            "cursor": "pointer",
            "font-size": "20px"
          },
          on: {
            "click": function click($event) {
              return _vm.$router.go(-1);
            }
          }
        }) : _vm._e(), _c('h4', {
          staticClass: "card-title text-primary mb-0"
        }, [_c('strong', [_vm._v("PMS FLEETS")])])])];
      },
      proxy: true
    }, {
      key: "body",
      fn: function fn() {
        var _vm$fleetDetail$compa, _vm$fleetDetail$vehic;
        return [_vm.isLoading ? _c('div', {
          staticClass: "text-center my-5"
        }, [_c('b-spinner', {
          attrs: {
            "label": "Loading..."
          }
        }), _c('p', {
          staticClass: "text-muted mt-2"
        }, [_vm._v("Loading data, please wait...")])], 1) : _c('div', [_c('div', {
          staticClass: "row no-gutters px-2 mb-3"
        }, [_vm.fleetDetail ? _c('div', {
          staticClass: "col-md-7 pr-md-3 mb-3"
        }, [_c('div', {
          staticClass: "card shadow-sm h-100 p-3"
        }, [_c('div', {
          staticClass: "row no-gutters"
        }, [_c('div', {
          staticClass: "col-md-6"
        }, [_c('div', {
          staticClass: "fleet-image pr-3"
        })]), _c('div', {
          staticClass: "col-md-6"
        }, [_c('div', {
          staticClass: "pl-3"
        }, [_c('div', {
          staticClass: "d-flex align-items-center mb-2"
        }, [_c('img', {
          staticClass: "icon-badge mr-2",
          attrs: {
            "src": require('../Components/Icons/icon-fleet.svg')
          }
        }), _c('div', [_c('h5', {
          staticClass: "mb-0 text-primary font-weight-bold"
        }, [_vm._v(" " + _vm._s(_vm.fleetDetail.name) + " "), _c('span', {
          staticClass: "ml-2 text-danger"
        }, [_vm._v("●")])]), _c('strong', {
          staticClass: "text-black mb-2"
        }, [_vm._v(" " + _vm._s((_vm$fleetDetail$compa = _vm.fleetDetail.company) === null || _vm$fleetDetail$compa === void 0 ? void 0 : _vm$fleetDetail$compa.company) + " ")])])]), _c('table', {
          staticClass: "table table-striped mb-0"
        }, [_c('tbody', [_c('tr', [_c('td', {
          staticClass: "text-muted"
        }, [_vm._v("Fleet Type")]), _c('td', {
          staticClass: "font-weight-bold text-capitalize"
        }, [_vm._v(" " + _vm._s((_vm$fleetDetail$vehic = _vm.fleetDetail.vehicle_type) === null || _vm$fleetDetail$vehic === void 0 ? void 0 : _vm$fleetDetail$vehic.name) + " ")])]), _c('tr', [_c('td', {
          staticClass: "text-muted"
        }, [_vm._v("Call Sign")]), _c('td', {
          staticClass: "font-weight-bold"
        }, [_vm._v(" " + _vm._s(_vm.fleetDetail.code) + " ")])]), _c('tr', [_c('td', {
          staticClass: "text-muted"
        }, [_vm._v("Flag")]), _c('td', {
          staticClass: "font-weight-bold"
        }, [_vm._v(" " + _vm._s(_vm.fleetDetail.flag) + " ")])]), _c('tr', [_c('td', {
          staticClass: "text-muted"
        }, [_vm._v("Year & Building")]), _c('td', {
          staticClass: "font-weight-bold"
        }, [_vm._v(" " + _vm._s(_vm.fleetDetail.year_build_country) + " ")])])])])])])])])]) : _vm._e(), _c('div', {
          staticClass: "col-md-5 pl-md-3 mb-3"
        }, [_c('div', {
          staticClass: "card shadow-sm h-100"
        }, [_c('div', {
          staticClass: "p-3 h-100 d-flex flex-column"
        }, [_c('div', {
          staticClass: "d-flex"
        }, [_c('div', {
          staticClass: "mr-2"
        }, [_c('img', {
          attrs: {
            "src": require("./Icons/clock-icon.svg")
          }
        })]), _c('div', {
          staticClass: "d-flex justify-content-between w-100 mb-2"
        }, [_c('div', [_c('h5', {
          staticClass: "mb-0 text-primary font-weight-bold"
        }, [_vm._v(" Total Running ")]), _c('div', {
          staticClass: "text-muted mb-3"
        }, [_vm._v(" Last Update : " + _vm._s(_vm.lastUpdate) + " ")])]), _c('b-button', {
          staticStyle: {
            "height": "max-content"
          },
          attrs: {
            "size": "sm",
            "variant": "warning",
            "disabled": _vm.isLoading
          }
        }, [_vm._v(" Detail RH ")])], 1)]), _c('table', {
          staticClass: "table table-striped mb-0"
        }, [_c('tbody', _vm._l(_vm.runningHours, function (item, i) {
          var _item$power_series, _item$power_series2;
          return _c('tr', {
            key: i
          }, [_c('td', {
            staticClass: "text-black",
            staticStyle: {
              "width": "60%"
            }
          }, [_c('strong', [_vm._v(" " + _vm._s(item.name) + " ")]), _c('br'), _c('small', [_vm._v(" " + _vm._s(item === null || item === void 0 ? void 0 : (_item$power_series = item.power_series) === null || _item$power_series === void 0 ? void 0 : _item$power_series.name) + " - " + _vm._s(item === null || item === void 0 ? void 0 : (_item$power_series2 = item.power_series) === null || _item$power_series2 === void 0 ? void 0 : _item$power_series2.model) + " ")])]), _c('td', {
            staticClass: "text-right font-weight-bold text-black"
          }, [_vm._v(" " + _vm._s(_vm.formatHours(item.hours)) + " Hours ")])]);
        }), 0)]), _c('div', {
          staticClass: "mt-auto"
        })])])])]), _c('div', {
          staticClass: "px-2 mb-3"
        }, [_c('PlanMaintenanceSummary', {
          attrs: {
            "meta": _vm.summaryData
          }
        })], 1), _c('div', {
          staticClass: "d-flex align-items-center px-2 mb-3"
        }, [_c('form', {
          on: {
            "submit": function submit($event) {
              $event.preventDefault();
              return _vm.fetchData.apply(null, arguments);
            }
          }
        }, [_c('b-form-input', {
          staticStyle: {
            "max-width": "260px"
          },
          attrs: {
            "placeholder": "Search Equipment Name",
            "disabled": _vm.isLoading
          },
          model: {
            value: _vm.filters.search,
            callback: function callback($$v) {
              _vm.$set(_vm.filters, "search", $$v);
            },
            expression: "filters.search"
          }
        })], 1), _c('b-button', {
          staticClass: "ml-2",
          attrs: {
            "variant": "outline-primary",
            "disabled": _vm.isLoading
          },
          on: {
            "click": function click($event) {
              _vm.showFilter = true;
            }
          }
        }, [_c('i', {
          staticClass: "fas fa-sliders"
        }), _vm._v(" Filter Data ")]), _c('b-button', {
          staticClass: "ml-auto",
          attrs: {
            "variant": "primary",
            "disabled": _vm.isLoading
          },
          on: {
            "click": _vm.handleExport
          }
        }, [_c('i', {
          staticClass: "fa fa-file-export mr-1"
        }), _vm._v(" Export ")])], 1), _c('div', {
          staticClass: "table-responsive px-2"
        }, [_c('table', {
          staticClass: "table align-middle table-striped table-bordered table-hover"
        }, [_c('thead', {
          staticClass: "thead-light"
        }, [_c('tr', [_c('th', {
          staticClass: "align-middle",
          attrs: {
            "rowspan": "2"
          }
        }, [_vm._v("Job Name")]), _c('th', {
          staticClass: "align-middle",
          attrs: {
            "rowspan": "2"
          }
        }, [_vm._v("Equipment")]), _c('th', {
          staticClass: "align-middle text-nowrap",
          attrs: {
            "rowspan": "2"
          }
        }, [_vm._v("Job Type")]), _c('th', {
          staticClass: "align-middle text-center",
          attrs: {
            "rowspan": "2"
          }
        }, [_vm._v("Interval")]), _c('th', {
          staticClass: "align-middle",
          attrs: {
            "rowspan": "2"
          }
        }, [_vm._v("Last")]), _c('th', {
          staticClass: "align-middle",
          attrs: {
            "rowspan": "2"
          }
        }, [_vm._v("Due")]), _c('th', {
          staticClass: "align-middle text-center",
          attrs: {
            "rowspan": "2"
          }
        }, [_vm._v("Status")]), _c('th', {
          staticClass: "text-center",
          attrs: {
            "colspan": "3"
          }
        }, [_vm._v("Work Status")]), _c('th', {
          staticClass: "align-middle text-center",
          attrs: {
            "rowspan": "2"
          }
        }, [_vm._v("Action")])]), _c('tr', [_c('th', {
          staticClass: "text-center"
        }, [_vm._v("On Time")]), _c('th', {
          staticClass: "text-center"
        }, [_vm._v("Overdue")]), _c('th', {
          staticClass: "text-center"
        }, [_vm._v("Postponed")])])]), _c('tbody', [_vm._l(_vm.paginatedRows, function (row, idx) {
          var _row$job_library, _row$last_maintenance, _row$maintenances, _row$maintenances2, _row$onTime;
          return _c('tr', {
            key: idx
          }, [_c('td', {
            staticClass: "p-0"
          }, [_c('div', {
            staticClass: "font-weight-bold p-2 px-3 text-nowrap"
          }, [_vm._v(" " + _vm._s(row === null || row === void 0 ? void 0 : (_row$job_library = row.job_library) === null || _row$job_library === void 0 ? void 0 : _row$job_library.name) + " ")]), (row === null || row === void 0 ? void 0 : row.method) == 'COUNTER' ? _c('div', {
            staticClass: "border-top p-2 px-3"
          }, [_c('small', {
            staticClass: "text-muted"
          }, [_vm._v(" " + _vm._s(row === null || row === void 0 ? void 0 : row.power_type_name) + " ")])]) : _vm._e()]), _c('td', {
            staticClass: "p-0"
          }, [_c('div', {
            staticClass: "font-weight-bold p-2 px-3 text-primary text-nowrap"
          }, [_vm._v(" " + _vm._s(row.equipment_name || '-') + " ")]), _c('div', {
            staticClass: "border-top p-2 px-3"
          }, [_c('small', {
            staticClass: "text-muted text-nowrap"
          }, [_vm._v(" " + _vm._s(row.component_name || '-') + " ")])])]), _c('td', {
            staticClass: "text-nowrap"
          }, [_c('div', {
            staticClass: "font-weight-bold"
          }, [_vm._v(_vm._s(row.job_type))]), _c('small', {
            staticClass: "text-muted"
          }, [_vm._v(_vm._s(row.job_class))])]), _c('td', {
            staticClass: "text-nowrap text-center"
          }, [_c('div', {
            staticClass: "font-weight-bold"
          }, [_vm._v(_vm._s(row.interval))]), _c('small', {
            staticClass: "text-muted"
          }, [_vm._v(_vm._s(row.method))])]), _c('td', [_c('div', {
            staticClass: "text-nowrap"
          }, [_vm._v(" " + _vm._s((_row$last_maintenance = row.last_maintenance) !== null && _row$last_maintenance !== void 0 ? _row$last_maintenance : '-') + " ")]), _c('div', {
            staticClass: "text-muted"
          }, [row.method === 'COUNTER' ? _c('strong', [_vm._v(" RH : " + _vm._s(_vm.formatHours(row.last_maintenance_hours)) + " Hours ")]) : _vm._e()])]), (row === null || row === void 0 ? void 0 : row.method) == 'CALENDAR' ? _c('td', [_vm._v(" " + _vm._s(_vm.formatDate((_row$maintenances = row.maintenances) === null || _row$maintenances === void 0 ? void 0 : _row$maintenances.possible_maintenance_date)) + " ")]) : _c('td', [_vm._v(" " + _vm._s(_vm.formatNumber((_row$maintenances2 = row.maintenances) === null || _row$maintenances2 === void 0 ? void 0 : _row$maintenances2.possible_maintenance_hours) || '0') + " Hours ")]), _c('td', {
            staticClass: "text-center"
          }, [_c('span', {
            staticClass: "badge",
            class: _vm.getStatusBadgeClass(row.status)
          }, [_vm._v(" " + _vm._s(row.status) + " ")])]), _c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s((_row$onTime = row === null || row === void 0 ? void 0 : row.onTime) !== null && _row$onTime !== void 0 ? _row$onTime : '-'))]), _c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s(row.overdue))]), _c('td', {
            staticClass: "text-center"
          }, [_vm._v(_vm._s(row.postponed))]), _c('td', {
            staticClass: "text-center"
          }, [_c('b-dropdown', {
            attrs: {
              "size": "sm",
              "variant": "outline-primary",
              "text": "Action",
              "right": ""
            }
          }, [_c('b-dropdown-item', {
            on: {
              "click": function click($event) {
                $event.preventDefault();
                return _vm.logAllHistory(row);
              }
            }
          }, [_vm._v(" Log All History ")]), _c('b-dropdown-item', {
            on: {
              "click": function click($event) {
                return _vm.deleteJob(row);
              }
            }
          }, [_vm._v(" Delete Job ")])], 1)], 1)]);
        }), !_vm.paginatedRows.length ? _c('tr', [_c('td', {
          staticClass: "text-center text-muted py-4",
          attrs: {
            "colspan": "11"
          }
        }, [_vm._v(" No data available ")])]) : _vm._e()], 2)])]), _vm.totalRows > 0 ? _c('div', {
          staticClass: "mt-3 d-flex align-items-center w-100 justify-content-between px-3 pb-2"
        }, [_c('div', [_vm._v(" Total Rows : "), _c('strong', [_vm._v(_vm._s(_vm.totalRows))])]), _c('div', {
          staticClass: "d-flex align-items-center"
        }, [_c('b-form-select', {
          staticClass: "mr-2",
          staticStyle: {
            "width": "140px"
          },
          attrs: {
            "options": _vm.limitOptions
          },
          on: {
            "change": _vm.onChangeLimit
          },
          model: {
            value: _vm.pagination.limit,
            callback: function callback($$v) {
              _vm.$set(_vm.pagination, "limit", $$v);
            },
            expression: "pagination.limit"
          }
        }), _c('b-pagination', {
          staticClass: "mb-0",
          attrs: {
            "total-rows": _vm.totalRows,
            "per-page": _vm.pagination.limit,
            "first-number": "",
            "align": "center"
          },
          model: {
            value: _vm.pagination.page,
            callback: function callback($$v) {
              _vm.$set(_vm.pagination, "page", $$v);
            },
            expression: "pagination.page"
          }
        })], 1)]) : _vm._e()])];
      },
      proxy: true
    }])
  }), _c('b-modal', {
    attrs: {
      "title": "Filter Data",
      "centered": ""
    },
    on: {
      "ok": _vm.fetchData
    },
    model: {
      value: _vm.showFilter,
      callback: function callback($$v) {
        _vm.showFilter = $$v;
      },
      expression: "showFilter"
    }
  }, [_c('div', {
    staticClass: "text-muted"
  }, [_vm._v("Filter form goes here…")])])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }